/**
 * This compoenent is called by
 * <PhotoSearch />
 * <EditPoto /> which is no longer used.
 */

import React, { useEffect, useState }           from 'react'
import axios                                    from 'axios'
import {
   Button,
   Grid,
   TextField,
   TextareaAutosize,
   Typography
}                                               from '@material-ui/core'
import {
   formPhotoTagArray,
   node_server
}                                               from '../Helpers'
import PropTypes                                from 'prop-types'

const EditPhotoFieldsComponent = props => {

   const { handleSnackBar, id, title }                                  =  props


   const [ caption,                             setCaption           ]  =  useState('')
   const [ fullFilename,                        setFullFilename      ]  =  useState('')
   const [ photoTags,                           setPhotoTags         ]  =  useState('')
   const [ smallFilename,                       setSmallFilename     ]  =  useState('')
   const [ thumbnailFilename,                   setThumbnailFilename ]  =  useState('')
   const [ tpsClass,                            setTpsClass          ]  =  useState('')

   useEffect( () => {
      fetchData()
      async function fetchData() {
         await axios.get( node_server + `photo/${id}` )
            .then( res => {

               let tempPhotoTags = ''

               res.data.photoTags.forEach((element, index) => {
                  if (index === res.data.photoTags.length - 1) {
                     tempPhotoTags = tempPhotoTags += element.tagText
                  }
                  else {
                     tempPhotoTags = tempPhotoTags += element.tagText + ','
                  }
               });

               setCaption(res.data.caption)
               setFullFilename(res.data.fullFilename)
               setPhotoTags(tempPhotoTags)
               setSmallFilename(res.data.smallFilename)
               setThumbnailFilename(res.data.thumbnailFilename)
               setTpsClass(res.data.tpsClass)
            }
         )
      }
  }, [ id ] )

   const changeCaption = (e) => {
      setCaption(e.target.value)
   }

   const changeFullFilename = (e) => {
      setFullFilename(e.target.value)
   }

   const changePhotoTags = (e) => {
      setPhotoTags(e.target.value)
   }

   const changeSmallFilename = (e) => {
      setSmallFilename(e.target.value)
   }

   const changeThumbnailFilename = (e) => {
      setThumbnailFilename(e.target.value)
   }

   const changeTpsClass = (e) => {
      setTpsClass(e.target.value)
   }

   const handleSubmit = async () => {
      const tagArray = await formPhotoTagArray(photoTags)

      axios.put(node_server + 'photo/edit', 
      {
         caption,
         fullFilename,
         id: id,
         photoTags: tagArray,
         smallFilename,
         thumbnailFilename,
         tpsClass
      })
      .then( res => {
         if (res.data.msg === 'good operation') {
            handleSnackBar({ msg: 'Your photo was edited!', type:'success' })
         }
         else {
            handleSnackBar({ msg: 'Photo edit error.', type:'error' })
         }
      })
   }

   return(
      <Grid>
         <Grid>
            <Typography variant='h4' style={{marginTop: '6rem'}} >
               {title}
            </Typography>
         </Grid>
         <Grid item xs={12} style={{ marginTop: '1rem' }}>
            <TextField data-testid='edit-photo-full-filename-input' label="Full Filename" onChange={changeFullFilename} variant='outlined' style={{ width: '90%' }} value={fullFilename} />
         </Grid>
         <Grid item xs={12} style={{ marginTop: '1rem' }}>
            <TextField data-testid='edit-photo-small-filename-input' label="Small Filename" onChange={changeSmallFilename} variant='outlined' style={{ width: '90%' }} value={smallFilename} />
         </Grid>
         <Grid item xs={12} style={{ marginTop: '1rem' }}>
            <TextField data-testid='edit-photo-thumbnail-filename-input' label="Thumbnail Filename" onChange={changeThumbnailFilename} variant='outlined' style={{ width: '90%' }} value={thumbnailFilename} />
         </Grid>
         <Grid item xs={12} style={{ marginTop: '1rem' }}>
            <TextField data-testid='edit-photo-photo-tag-input' label="Photo Tag(s), comma delimited, no spaces" onChange={changePhotoTags} variant='outlined' style={{ width: '90%' }} value={photoTags} />
         </Grid>
         <Grid item xs={12} style={{ marginTop: '1rem' }}>
            <TextField data-testid='edit-photo-tps-class-input' label="TPS Class" onChange={changeTpsClass} variant='outlined' style={{ width: '90%' }} value={tpsClass} />
         </Grid>
         <Grid item xs={12} style={{ marginTop: '1rem' }}>
            <TextareaAutosize data-testid='edit-photo-caption-input' name='Caption' placeholder={'Caption'} minRows={5} style={{ width: '90%', fontSize: '1.5rem', padding: '0.5rem' }} onChange={changeCaption} value={caption} />
         </Grid>
         <Grid item style={{ marginTop: '1rem' }}>
            <Button data-testid='edit-photo-submit-button' variant='contained' color='primary' onClick={handleSubmit}>Submit</Button>
         </Grid>
      </Grid>
   )
}

EditPhotoFieldsComponent.propTypes = {
   handleSnackBar: PropTypes.func,
   id: PropTypes.string,
   title: PropTypes.string
}

export default EditPhotoFieldsComponent